import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { IoIosAppstore } from "react-icons/io";
import { BiLogoPlayStore } from "react-icons/bi";
import { Row, Col } from "react-bootstrap";
import { FaStripe, FaNodeJs, FaCode, FaBluetooth } from "react-icons/fa";
import {
  SiFlutter,
  SiPostgresql,
  SiPostman,
  SiAndroidstudio,
  SiXcode,
  SiGooglecloud,
  SiAlgolia,
  SiSqlite,
  SiGooglefit,
  SiCodemagic,
} from "react-icons/si";
import { IoIosNotifications, IoIosBluetooth } from "react-icons/io";
import { TbBrandXamarin } from "react-icons/tb";
import { DiVisualstudio } from "react-icons/di";
import { RiFirebaseFill } from "react-icons/ri";

function ProjectCards(props) {
  const getIcon = (tech) => {
    const iconMap = {
      // Technologies
      flutter: <SiFlutter className="text-info" />,
      maui: <TbBrandXamarin className="text-primary" />,
      xamarin: <TbBrandXamarin className="text-primary" />,
      bluetooth: <IoIosBluetooth className="text-primary" />,
      sqlite: <SiSqlite className="text-primary" />,
      firebase: <RiFirebaseFill className="text-warning" />,
      codemagic: <SiCodemagic className="text-primary" />,
      push: <IoIosNotifications className="text-primary" />,
      nodejs: <FaNodeJs className="text-success" />,
      postgres: <SiPostgresql className="text-primary" />,
      cloudfunctions: <SiGooglecloud className="text-primary" />,
      algolia: <SiAlgolia className="text-primary" />,
      stripe: <FaStripe className="text-primary" />,
      healthkit: <SiGooglefit className="text-danger" />,

      // Tools
      xcode: <SiXcode className="text-primary" />,
      vscode: <DiVisualstudio className="purple" />,
      androidstudio: <SiAndroidstudio className="text-success" />,
      postman: <SiPostman className="text-danger" />,
      visualstudio: <DiVisualstudio className="text-purple" />,
    };

    return iconMap[tech.toLowerCase()] || <FaCode />; // Default icon if not found
  };

  console.log(props.techs);
  return (
    <Card className="project-card-view">
      <Card.Body>
        <Card.Title>
          <h4 className="mb-3">{props.title}</h4>
        </Card.Title>
        <Card.Text
          style={{ textAlign: "justify" }}
          className="text-secondary mb-4"
        >
          {props.description}
        </Card.Text>

        <div className="technology">
          <Row className="align-items-center">
            <Col xs="auto" className="mb-3 text-center">
              <h6 className="purple mb-0">Techs:</h6>
            </Col>
            <Col xs="auto" className="mb-3 text-center">
              <div className="icon-container">
                {props.techs.map((tech, index) => (
                  <div key={index} className="tech-icon" title={tech}>
                    <h4 className="mb-0">{getIcon(tech)}</h4>
                  </div>
                ))}
              </div>
            </Col>
          </Row>

          <Row className="align-items-center">
            <Col xs="auto" className="mb-3 text-center">
              <h6 className="purple mb-0">Tools:</h6>
            </Col>
            <Col xs="auto" className="mb-3 text-center">
              <div className="icon-container">
                {props.tools.map((tool, index) => (
                  <div key={index} className="tech-icon" title={tool}>
                    <h4 className="mb-0">{getIcon(tool)}</h4>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </div>

        <Row>
          <Col xs={12} md="auto" className="mb-3 mb-md-0">
            {props.appStoreLink && (
              <Button
                variant="primary"
                href={props.appStoreLink}
                target="_blank"
                className="w-100"
              >
                <IoIosAppstore /> &nbsp; App Store
              </Button>
            )}
          </Col>
          <Col xs={12} md="auto" className="text-end ms-auto">
            {props.playStoreLink && (
              <Button
                variant="primary"
                href={props.playStoreLink}
                target="_blank"
                className="w-100"
              >
                <BiLogoPlayStore /> &nbsp;
                {"Play Store"}
              </Button>
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
